import styled from "styled-components";
import { useEffect, useRef, useState } from "react";
import { faSearch, faTimesCircle } from "@fortawesome/pro-solid-svg-icons";

import { Tooltip } from "common/components/tooltip";

import { Icon } from "./icon";

export function TextInput({
    icon, clear, onFocus = () => {}, onBlur = () => {}, ...props
}) {
    const [isEditing, setEditing] = useState(false);
    const inputRef = useRef();
    
    useEffect(() => {
        if (isEditing && isEditing) {
            inputRef.current.focus();
        }
    });
    
    const onFocusFn = (e) => {
        setEditing(true);
        onFocus(e);
    };
    
    const onBlurFn = (e) => {
        setEditing(false);
        onBlur(e);
    };
    
    const clearFn = (e) => {
        inputRef.current.value = "";
        setEditing(true);
    };
    
    // Need to wrap Icon inside inline block to make Tooltip properly positioned
    return (
        <InputWrapper>
            {icon && <PrefixIcon size={4} icon={icon} onClick={() => setEditing(true)}/>}
            <StyledInput ref={inputRef} {...props} onFocus={onFocusFn} onBlur={onBlurFn}/>
            {clear && <Tooltip title="Clear"><span><Icon $shouldHover fontSize={5} icon={faTimesCircle} onClick={clearFn} /></span></Tooltip>}
        </InputWrapper>
    );
}

export function SearchInput({ icon, clear, ...props } = {}) {
    return <TextInput icon={faSearch} clear {...props} />;
}

TextInput.defaultProps = {
    icon: null,
    clear: false
};

const StyledInput = styled("input").withConfig({
    // Do not forward required to `input` to avoid default browser behavior
    shouldForwardProp: (prop, defaultValidatorFn) => !["required"].includes(prop) && defaultValidatorFn(prop)
})`
    padding: 0;
    border: none;
    outline: none;
    width: 100%;
    font-feature-settings: "tnum";
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    margin: 0;
    font-variant: tabular-nums;
    list-style: none;
    min-width: 0;
    
    &:placeholder-shown {
        text-overflow: ellipsis;
    }
`;

const InputWrapper = styled.div`
    position: relative;
    width: 100%;
    min-width: 0;
    padding: ${(props) => props.theme.space(0.5)} ${(props) => props.theme.space(1)};
    color: ${(props) => props.theme.textColor};
    font-size: ${(props) => props.theme.fontSizeLarge};
    background-color: ${(props) => props.theme.colors.white};
    border: 1px solid ${(props) => props.theme.colors["gray-soft"]};
    border-radius: ${(props) => props.theme.borderRadius};
    display: inline-flex;
    align-items: center;
    
    &:hover {
        border-color: ${(props) => props.theme.colors["blue-light"]};
        border-right-width: 1px !important;
        z-index: 1;
    }
    
    &:focus {
        outline: 0;
        box-shadow: 0 0 0 2px ${(props) => props.theme.colors["blue-light"]};
    }
`;

const PrefixIcon = styled(Icon)`
    margin-right: 4px;
`;
